import { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import EG from "../../assets/images/eg.png"
import US from "../../assets/images/us.png"
import { useTranslation } from "react-i18next";
const LanguageDropdown = ({ i18n, changeLanguage }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef();
    const { t } = useTranslation();

    const languages = [
        { value: "ar", label: "settings.arabic", flag: EG },
        { value: "en", label: "settings.english", flag: US },
    ];

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const currentLang = languages.find((l) => l.value === i18n.language);

    return (
        <div className="relative inline-block" ref={ref}>
            <button
                onClick={() => setOpen(!open)}
                className="flex items-center gap-2 px-4 py-2 transition rounded-lg dark:text-text-muted-dark text-text-muted-light bg-bg-light-secondary dark:bg-bg-dark-secondary hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
            >
                <img src={currentLang.flag} alt={t(`${currentLang?.label}`)} className="w-6 h-4" />
                <span>{t(`${currentLang?.label}`)}</span>
                <ChevronDownIcon className={`w-4 h-4 transition-transform ${open ? "rotate-180" : "rotate-0"}`} />
            </button>

            {/* menu */}
            {open && (
                <div className="absolute left-0 z-50 mt-2 rounded-lg shadow-glow w-36 bg-bg-light-secondary dark:bg-bg-dark-secondary ">
                    {languages.map((lang) => (
                        <div
                            key={lang.value}
                            onClick={() => {
                                changeLanguage(lang.value);
                                setOpen(false);
                            }}
                            className={`flex items-center gap-2 px-4 rounded-lg py-2 cursor-pointer hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary transition
                ${i18n.language === lang.value ? "font-semibold" : ""}`}
                        >
                            <img src={lang.flag} alt={t(`${lang.label}`)} className="w-4 h-2" />
                            <span>{t(`${lang.label}`)}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageDropdown;
